module.exports = "/build/web/svg/social/small/verified-instagram.5efe1791415caaa35c10efa5ffa80d23.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/social/small/verified-instagram.svg
// module id = 115
// module chunks = 24